import clientApi, { notSupport, CLIENT_FLAG } from '@plus/client-connect';
import { getHost as getHost$1 } from '@plus/env/dist/getHost';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function unfetch(url, options) {
    options = options || {};
    return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        var keys = [];
        var all = [];
        var headers = {};
        var response = function () { return ({
            ok: (request.status / 100 | 0) == 2,
            statusText: request.statusText,
            status: request.status,
            url: request.responseURL,
            text: function () { return Promise.resolve(request.responseText); },
            json: function () { return Promise.resolve(request.responseText).then(JSON.parse); },
            blob: function () { return Promise.resolve(new Blob([request.response])); },
            clone: response,
            headers: {
                keys: function () { return keys; },
                entries: function () { return all; },
                get: function (n) { return headers[n.toLowerCase()]; },
                has: function (n) { return n.toLowerCase() in headers; }
            }
        }); };
        request.open((options === null || options === void 0 ? void 0 : options.method) || 'get', url, true);
        request.onload = function () {
            request.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (m, key, value) {
                keys.push(key = key.toLowerCase());
                all.push([key, value]);
                headers[key] = headers[key] ? "".concat(headers[key], ",").concat(value) : value;
                return m;
            });
            resolve(response());
        };
        request.onerror = reject;
        request.withCredentials = (options === null || options === void 0 ? void 0 : options.credentials) == 'include';
        for (var i in options === null || options === void 0 ? void 0 : options.headers) {
            request.setRequestHeader(i, options.headers[i]);
        }
        request.send((options === null || options === void 0 ? void 0 : options.body) || null);
    });
}
function fetch(url, options) {
    if (window.fetch) {
        return window.fetch(url, options);
    }
    return unfetch(url, options);
}
var def = {
    method: 'GET',
    credentials: 'include',
    headers: {
        'content-type': 'application/json'
    }
};
function request(url, options) {
    var _this = this;
    options = Object.assign({}, def, options || {});
    options.method = (options.method || 'GET').toUpperCase();
    if (typeof options.body == 'object') {
        options.body = JSON.stringify(options.body);
    }
    return fetch(url, __assign({}, options)).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, res.json()];
                case 1:
                    data = _a.sent();
                    if (res.ok) {
                        return [2 /*return*/, data];
                    }
                    throw data;
            }
        });
    }); });
}

// 当前是否金山文档域名
var isKdocsDomain = window.location.origin.indexOf('kdocs.cn') !== -1;
var isWpsPlusDomain = window.location.origin.indexOf('wpsplus.com') !== -1;
// 是否同一个域
var isSameDomain = function (aurl, burl) {
    return new URL(aurl).hostname.split('.').slice(-2).join('.') === new URL(burl).hostname.split('.').slice(-2).join('.');
};
var setUrlQuery = function (url, params) {
    var querys = [];
    for (var key in params) {
        querys.push(key + '=' + String(params[key]));
    }
    return "".concat(url, "?").concat(querys.join('&'));
};
var getCbUrl = function (s, clientName, defVal) {
    if (!s || typeof s === 'string') {
        return s || defVal;
    }
    return s[clientName || 'default'] || s.default || defVal;
};
// accessID 在生产和beta有固定的值，更建议通过kae构建参数定义，为了降低使用成本，判断环境使用默认的 appid
var kdocsAppid = {
    dev: 'AK20181211LIODSU',
    prod: 'AK20200311SMDNJR'
};
var wpsplusAppid = {
    dev: 'AK20200311SMDNJR',
    prod: 'AK20200317NIXICH'
};
var getKdocsAppid = function () {
    var accessID = kdocsAppid.prod; // 生产环境 appid
    try {
        // @ts-ignore
        if (process.env.NODE_ENV === 'development' || process.env.KAE_ENVIRONMENT === 'beta' || process.env.VUE_APP_KAE_ENVIRONMENT === 'beta' || process.env.VITE_APP_KAE_ENVIRONMENT === 'beta') {
            accessID = kdocsAppid.dev; // beta 环境 appid
        }
        // @ts-ignore
        accessID = process.env.VITE_APP_KAE_ACCESSID || process.env.VUE_APP_KAE_ACCESSID || accessID; // 构建指定 appid
    }
    catch (e) { }
    return accessID;
};
var getWpsplusAppid = function () {
    var accessID = wpsplusAppid.prod; // 生产环境 appid
    try {
        // @ts-ignore
        if (process.env.NODE_ENV === 'development' || process.env.KAE_ENVIRONMENT === 'beta' || process.env.VUE_APP_KAE_ENVIRONMENT === 'beta' || process.env.VITE_APP_KAE_ENVIRONMENT === 'beta') {
            accessID = wpsplusAppid.dev; // beta 环境 appid
        }
    }
    catch (e) { }
    return accessID;
};
var jumpUrl = function (url) { return (window.top || window.self || window).location.replace(url); };
// 这里只能硬编码，用于跳转到账号页面，而页面地址应该是固定 wps.cn 的，@plus/env 的域名变量会随着域名变化而改变
var ACCOUNT = "https://account.wps.cn";
var KDOCS = "https://www.kdocs.cn";
var WPSPLUS = "https://wpsplus.com";
var PLUS = "https://plus.wps.cn";
var wpsplus3rd = {
    DOCS: "".concat(WPSPLUS, "/3rd/docs"),
    DRIVE: "".concat(WPSPLUS, "/3rd/drive"),
    ACCOUNT: "".concat(WPSPLUS, "/3rd/account"),
    PLUSSVR: "".concat(WPSPLUS, "/3rd/plussvr"),
    PLUS: "".concat(WPSPLUS, "/3rd/plus"),
    SYSADMIN: "".concat(WPSPLUS, "/3rd/sysadmin"),
    STORE: "".concat(WPSPLUS, "/3rd/store"),
    WORK: "".concat(WPSPLUS, "/3rd/work")
};
var getHost = function (name) {
    if (isSameDomain(WPSPLUS, window.location.href) && wpsplus3rd[name]) {
        return wpsplus3rd[name];
    }
    return getHost$1(name);
};

// 获取当前用户
var userCheck = function () {
    return request("".concat(getHost("ACCOUNT"), "/p/auth/check"), {
        method: "POST",
        body: {},
    });
};
// 账号切换
var webChangeLogin = function (userid) {
    return request("".concat(getHost("ACCOUNT"), "/api/v3/login/web_change_login"), {
        method: "POST",
        body: {
            userid: userid,
        },
    });
};
// 免验证登录并切换账号
var webLogin = function (param) {
    return request("".concat(getHost("ACCOUNT"), "/api/v3/login/web_login"), {
        method: 'POST',
        body: {
            ssid: param.ssid,
            userids: param.userids.join(',')
        }
    });
};
// 获取账号列表
var getAccounts$1 = function (mode) {
    if (mode === void 0) { mode = 'current_login'; }
    return request("".concat(getHost("PLUSSVR"), "/compose/v1/u/related_users?role_ids=0&role_ids=1&role_ids=2&role_ids=3&mode=").concat(mode)).then(function (r) { return r.users; });
};
var fixAccountData = function (list) {
    return list.map(function (item) {
        return {
            userid: Number(item.userid || item.userId || 0),
            nickname: item.nickname || item.nickName,
            avatar_url: item.avatar_url || item.avatarUrl,
            company_logo: item.company_logo || item.companyLogo || '',
            company_id: Number(item.company_id || item.companyId || 0),
            company_name: item.company_name || item.companyName,
            is_company_account: item.is_company_account,
            status: Number(item.status || 0),
            reason: item.reason,
            is_current: item.is_current,
            is_login: item.is_login,
        };
    });
};
/**
 * 兼容遗留企业数据
 */
var fixLegacyAccounts = function (accounts, currentCompid) {
    accounts = fixAccountData(accounts);
    var current = accounts.find(function (info) { return info.is_current; });
    if (!current) {
        current = accounts.find(function (info) { return info.company_id == 0; });
    }
    if (!current && accounts.length) {
        current = accounts[0];
    }
    if (current) {
        accounts = accounts.map(function (info) {
            if (info.userid == current.userid) {
                info.is_current = true;
            }
            else {
                info.is_current = false;
            }
            return info;
        });
    }
    // 排序规则：正在使用的置顶，然后企业ID递增，然后userid递增
    var list = accounts.sort(function (x, y) {
        if (x.is_current != y.is_current) {
            if (x.is_current) {
                return -1;
            }
            if (y.is_current) {
                return 1;
            }
        }
        if (typeof currentCompid === 'number') {
            if (x.company_id == currentCompid) {
                return -1;
            }
            if (y.company_id == currentCompid) {
                return 1;
            }
        }
        if (x.company_id == y.company_id) {
            return x.userid > y.userid ? 1 : -1;
        }
        return x.company_id > y.company_id ? 1 : -1;
    });
    return list;
};

var isNotSupport = function (e) {
    return (e === null || e === void 0 ? void 0 : e.message) == notSupport.message;
};
// 获取账号列表
var getAccounts = function (mode) {
    if (mode === void 0) { mode = 'current_login'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var list, source, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(mode === 'current_login')) return [3 /*break*/, 6];
                    list = void 0;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    source = clientApi.getCurrentClient();
                    return [4 /*yield*/, clientApi.getLoginList({
                            clientName: source,
                        })];
                case 2:
                    list = _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    if (!isNotSupport(e_1)) {
                        throw e_1;
                    }
                    return [4 /*yield*/, getAccounts$1('current_login')];
                case 4:
                    list = _a.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, list];
                case 6: return [2 /*return*/, getAccounts$1(mode)];
            }
        });
    });
};
// 账号切换
var changeAccount = function (userid, ext) { return __awaiter(void 0, void 0, void 0, function () {
    var source, res, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                source = clientApi.getCurrentClient();
                return [4 /*yield*/, clientApi.switchAccount({
                        clientName: source,
                        userid: String(userid),
                        companyid: ext.companyid,
                        cbURL: getCbUrl(ext.cbUrl, source),
                        from: ext.from,
                    })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
            case 2:
                e_2 = _a.sent();
                if (!isNotSupport(e_2)) {
                    throw e_2;
                }
                return [2 /*return*/, webChangeLogin(userid)];
            case 3: return [2 /*return*/];
        }
    });
}); };
var ssidLogin = function (param) { return __awaiter(void 0, void 0, void 0, function () {
    var source, res, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                source = clientApi.getCurrentClient();
                return [4 /*yield*/, clientApi.addAccount({
                        ssid: param.ssid,
                        companyid: String(param.companyid) || '0',
                        userid: String(param.userids.join(',')),
                        clientName: source,
                        from: param.from
                    })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
            case 2:
                e_3 = _a.sent();
                if (!isNotSupport(e_3)) {
                    throw e_3;
                }
                return [2 /*return*/, webLogin(param)];
            case 3: return [2 /*return*/];
        }
    });
}); };
var getLoginAccountPage = function (params) {
    return setUrlQuery("".concat(ACCOUNT), params);
};
var goLoginAccountPage = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var source, cb, res, e_4, cb, url;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                source = clientApi.getCurrentClient();
                cb = typeof params.cb === 'string' ? params.cb : (((_a = params.cb) === null || _a === void 0 ? void 0 : _a[source || 'default']) || window.location.href);
                return [4 /*yield*/, clientApi.openLogin({
                        clientName: source,
                        from: params.from,
                        cbURL: cb
                    })];
            case 1:
                res = _c.sent();
                return [2 /*return*/, res];
            case 2:
                e_4 = _c.sent();
                if (!isNotSupport(e_4)) {
                    throw e_4;
                }
                cb = typeof params.cb === 'string' ? params.cb : (((_b = params.cb) === null || _b === void 0 ? void 0 : _b.default) || window.location.href);
                url = getLoginAccountPage(__assign(__assign({}, params), { cb: cb }));
                jumpUrl(url);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };

var getJumpErr = function (cb) {
    var needJumpErr = new Error('need jump, try to set canJump: true');
    // @ts-ignore
    needJumpErr.cbUrl = cb;
    return needJumpErr;
};
var getSafeVerifyPage = function (params) {
    return setUrlQuery("".concat(ACCOUNT, "/v1/saveverify"), params);
};
var getChangeAccountPage = function (params) {
    return setUrlQuery("".concat(ACCOUNT, "/v1/changeaccount"), params);
};
var getPlusAccountSignin = function (params) {
    return setUrlQuery("".concat(PLUS, "/fab/account_signin/"), params);
};
var getRedirectSSO = function (_a) {
    var cbUrl = _a.cbUrl, appid = _a.appid;
    var cb = typeof cbUrl === 'string' ? cbUrl : ((cbUrl === null || cbUrl === void 0 ? void 0 : cbUrl.default) || window.location.href);
    if (!appid) {
        appid = getKdocsAppid();
    }
    var pageUrl = "".concat(ACCOUNT, "/api/v3/session/correlate/redirect?appid=").concat(appid, "&cb=").concat(encodeURIComponent(cb));
    return pageUrl;
};
var getSingleSignSwitch = function (userid, param) {
    var cb = getRedirectSSO(param);
    var pageUrl = getChangeAccountPage({
        userid: userid,
        from: 'plus-singlesign-web',
        cb: encodeURIComponent(cb)
    });
    return pageUrl;
};
// 金山文档单点登录实现
var kdocsSingleSignSwitch = function (userid, ext) {
    return new Promise(function (resolve, reject) {
        var _a;
        var cb = typeof ext.cbUrl === 'string' ? ext.cbUrl : (((_a = ext.cbUrl) === null || _a === void 0 ? void 0 : _a.default) || window.location.href);
        if (!isSameDomain(ACCOUNT, window.location.origin)) {
            cb = "".concat(KDOCS, "/singleSign4CST?cb=").concat(encodeURIComponent(cb));
            // 如果不同域，cookie是会写入失败的，调用了 webChangeLogin 也不会正常切换，只能走单点登录
            if (!ext.canJump) {
                reject(getJumpErr(cb));
                return;
            }
            var pageUrl = getSingleSignSwitch(userid, { appid: ext.appid, cbUrl: cb });
            if (ext.ssid) {
                pageUrl = getPlusAccountSignin({
                    ssid: ext.ssid,
                    userid: userid,
                    cb: encodeURIComponent(pageUrl)
                });
            }
            jumpUrl(pageUrl);
            return;
        }
        else {
            resolve(apiSwitch(userid, ext));
        }
    });
};
// Wpsplus.com 单点登录实现
var wpsplusSingleSignSwitch = function (userid, ext) {
    return new Promise(function (resolve, reject) {
        var _a;
        var cb = typeof ext.cbUrl === 'string' ? ext.cbUrl : (((_a = ext.cbUrl) === null || _a === void 0 ? void 0 : _a.default) || window.location.href);
        if (!isSameDomain(ACCOUNT, window.location.origin)) {
            cb = "".concat(WPSPLUS, "/singleSign4CST?cb=").concat(encodeURIComponent(cb));
            // 如果不同域，cookie是会写入失败的，调用了 webChangeLogin 也不会正常切换，只能走单点登录
            if (!ext.canJump) {
                reject(getJumpErr(cb));
                return;
            }
            cb = getRedirectSSO({ appid: getWpsplusAppid(), cbUrl: cb });
            var pageUrl = getPlusAccountSignin({
                ssid: ext.ssid || '',
                userid: userid,
                cb: encodeURIComponent(cb)
            });
            jumpUrl(pageUrl);
            return;
        }
        else {
            resolve(apiSwitch(userid, ext));
        }
    });
};
// web 实现
var apiSwitch = function (userid, ext) {
    return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        var source, cb, isSSidLogin, loginPromise;
        return __generator(this, function (_a) {
            source = clientApi.getCurrentClient();
            cb = getCbUrl(ext.cbUrl, source, window.location.href);
            isSSidLogin = !!ext.ssid;
            if (isSSidLogin) {
                loginPromise = ssidLogin({
                    companyid: String(ext.companyid || ''),
                    userids: [userid],
                    from: ext.from,
                    ssid: ext.ssid
                });
            }
            else {
                loginPromise = changeAccount(userid, ext);
            }
            loginPromise.then(function () {
                resolve();
            }).catch(function (e) {
                if (e === null || e === void 0 ? void 0 : e.result) {
                    var pageUrl = '';
                    if (e.result == 'NeedSecondVerify') {
                        // 二次验证
                        pageUrl = getSafeVerifyPage({
                            userid: userid,
                            from: 'plus-web',
                            changeaccount: true,
                            cb: encodeURIComponent(cb)
                        });
                    }
                    else if (e.result == 'HaveNotVerify') {
                        // 验证过期或者登录后未选账号
                        pageUrl = getChangeAccountPage({
                            userid: userid,
                            from: 'plus-web',
                            cb: encodeURIComponent(cb)
                        });
                    }
                    else if (e.result == 'UserNotExists' || isSSidLogin) {
                        if (source == CLIENT_FLAG.IS_BROWSER_CLIENT) {
                            // 错误码是用户不存在，但是其含义可能是：1. 用户不存在 2. 用户存在但是未登录
                            pageUrl = getLoginAccountPage({
                                from: 'plus-web',
                                cb: encodeURIComponent(cb),
                                autologin: 'false'
                            });
                        }
                        else if (ext.canJump) {
                            // 调用客户端登录
                            goLoginAccountPage({
                                from: 'plus-web',
                                cb: encodeURIComponent(cb),
                                autologin: 'false'
                            });
                            return;
                        }
                    }
                    else {
                        reject(new Error((e === null || e === void 0 ? void 0 : e.result) || e || 'unknow error'));
                        return;
                    }
                    if (!ext.canJump || source != CLIENT_FLAG.IS_BROWSER_CLIENT) {
                        reject(getJumpErr(pageUrl));
                        return;
                    }
                    jumpUrl(pageUrl);
                    return;
                }
                reject(e);
            });
            return [2 /*return*/];
        });
    }); });
};
var isClientSupport = function (apiName) { return __awaiter(void 0, void 0, void 0, function () {
    var source;
    return __generator(this, function (_a) {
        try {
            source = clientApi.getCurrentClient();
            return [2 /*return*/, clientApi.checkClientAPISupport(source, apiName)];
        }
        catch (e) {
            return [2 /*return*/, false];
        }
        return [2 /*return*/];
    });
}); };
/**
 * 统一封装账号切换
 * @param userid 用户ID
 * @param ext 扩展参数，根据不同平台参数类型会不一样
 */
function switchAccount(userid, ext) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, isClientSupport(ext.ssid ? 'addAccount' : 'switchAccount')];
                case 1:
                    // 先确定是否在端内，如果是端内直接走端的方法
                    if (_a.sent()) {
                        return [2 /*return*/, apiSwitch(userid, ext)];
                    }
                    if (isKdocsDomain) {
                        // kdocs 域名单点登录
                        return [2 /*return*/, kdocsSingleSignSwitch(userid, ext)];
                    }
                    else if (isWpsPlusDomain) {
                        // wpsplus.com 域名单点登录
                        return [2 /*return*/, wpsplusSingleSignSwitch(userid, ext)];
                    }
                    // 默认 web 页面切换
                    return [2 /*return*/, apiSwitch(userid, ext)];
            }
        });
    });
}

// 企业的清洗状态
var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["noaccess"] = "noaccess";
    CompanyStatus["normal"] = "normal";
    CompanyStatus["legacy"] = "legacy";
})(CompanyStatus || (CompanyStatus = {}));
// 企业的当前状态
var CompanyState;
(function (CompanyState) {
    CompanyState["noaccess"] = "noaccess";
    CompanyState["related"] = "related";
    CompanyState["login"] = "login";
    CompanyState["current"] = "current";
})(CompanyState || (CompanyState = {}));
var getAccountDefaultParam = {
    legacy: false,
    mode: 'current_login'
};
var storageEventKey = '__multi_account_event';
var storageCompID = '__multi_account_companyid';
var globalInstanceCacheKey = '__multi_account_instance_cache';
var getCache = function (key, defaultValue) {
    var cache = window[globalInstanceCacheKey];
    if (cache && cache.hasOwnProperty(key)) {
        return cache[key];
    }
    if (!cache) {
        cache = {};
        window[globalInstanceCacheKey] = cache;
    }
    cache[key] = defaultValue;
    return cache[key];
};
var setCache = function (key, value) {
    var cache = window[globalInstanceCacheKey];
    if (!cache) {
        cache = {};
        window[globalInstanceCacheKey] = cache;
    }
    cache[key] = value;
};
var MultiAccount = /** @class */ (function () {
    function MultiAccount() {
        var _this = this;
        // 账号单点登录时需要的 appid
        this.accountAppid = "";
        /**
         * 用户身份发生变化后触发回调
         */
        this.accountChangeHandler = [];
        this.listenUserChange();
        this.onAccountChange(function () {
            _this.resetList();
        });
    }
    // 跳转到登录页
    MultiAccount.prototype.goLoginAccountPage = function (param) {
        goLoginAccountPage(param);
    };
    Object.defineProperty(MultiAccount.prototype, "accounts", {
        get: function () {
            return getCache('accounts', []);
        },
        set: function (v) {
            setCache('accounts', v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiAccount.prototype, "companyid", {
        get: function () {
            return getCache('companyid') || Number(localStorage.getItem(storageCompID)) || 0;
        },
        set: function (v) {
            setCache('companyid', v);
            localStorage.setItem(storageCompID, String(v));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiAccount.prototype, "listCaches", {
        get: function () {
            return getCache('listCaches', {
                current_login: [],
                all_bind: [],
            });
        },
        set: function (v) {
            setCache('listCaches', v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiAccount.prototype, "isFetched", {
        get: function () {
            return getCache('isFetched');
        },
        set: function (v) {
            setCache('isFetched', v);
        },
        enumerable: false,
        configurable: true
    });
    // 当前环境是否支持多账号功能
    MultiAccount.prototype.isClientSupport = function (apiName) {
        if (apiName === void 0) { apiName = 'switchAccount'; }
        // 浏览器所有都支持
        try {
            var source = clientApi.getCurrentClient();
            if (source == CLIENT_FLAG.IS_BROWSER_CLIENT) {
                return true;
            }
        }
        catch (e) { }
        // 其他根据端判断
        return isClientSupport(apiName);
    };
    // 账号列表
    // listCaches: Record<GetAccountMode, AccountInfo[]> = {
    //   all_bind: [],
    //   current_login: []
    // }
    // accounts: AccountInfo[] = [];
    // companyid?: number = Number(localStorage.getItem(storageCompID)) || 0
    // 手动设置账号列表
    MultiAccount.prototype.setAccounts = function (accounts, mode) {
        if (mode === void 0) { mode = 'current_login'; }
        this.accounts = fixLegacyAccounts(accounts, this.companyid);
        this.isFetched = mode;
        this.listCaches = {
            current_login: [],
            all_bind: []
        };
        this.listCaches[this.isFetched] = this.accounts;
    };
    // 避免获取为空时重复多次获取
    // private isFetched: AccountListMode | '' = ''
    // 获取账号列表
    MultiAccount.prototype.getAccounts = function (param) {
        var _a, _b;
        if (param === void 0) { param = getAccountDefaultParam; }
        return __awaiter(this, void 0, void 0, function () {
            var legacy, mode, accounts;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        // 兼容旧 api，参数是 boolean 值指定 legacy
                        if (typeof param === 'boolean') {
                            param = {
                                legacy: param,
                                mode: 'current_login'
                            };
                        }
                        legacy = param.legacy, mode = param.mode;
                        if (!(this.isFetched != mode)) return [3 /*break*/, 4];
                        accounts = void 0;
                        if (!((_a = this.listCaches[mode]) === null || _a === void 0 ? void 0 : _a.length)) return [3 /*break*/, 1];
                        accounts = this.listCaches[mode];
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, getAccounts(mode).catch(function () { return []; })];
                    case 2:
                        accounts = _c.sent();
                        _c.label = 3;
                    case 3:
                        this.accounts = fixLegacyAccounts(accounts, this.companyid);
                        this.listCaches[mode] = accounts;
                        this.isFetched = mode;
                        _c.label = 4;
                    case 4:
                        this.accounts = fixLegacyAccounts(this.accounts, this.companyid);
                        // 如果当前是企业账号，设置正确的企业id
                        this.companyid = ((_b = this.accounts.find(function (info) { return info.is_company_account && info.is_current; })) === null || _b === void 0 ? void 0 : _b.company_id) || this.companyid;
                        if (legacy) {
                            return [2 /*return*/, this.accounts];
                        }
                        return [2 /*return*/, this.accounts.filter(function (info) { return info.is_company_account || info.company_id === 0; })];
                }
            });
        });
    };
    // 获取所有关联账号和已登录账号
    MultiAccount.prototype.getAllModeAccounts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, relatedList, loginList;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.getAccounts({
                                legacy: true,
                                mode: 'all_bind'
                            }), this.getAccounts({
                                legacy: true,
                                mode: 'current_login'
                            })])];
                    case 1:
                        _a = _b.sent(), relatedList = _a[0], loginList = _a[1];
                        relatedList === null || relatedList === void 0 ? void 0 : relatedList.forEach(function (item) {
                            var _a = item || {}, companyid = _a.company_id, userid = _a.userid;
                            var isLogin = loginList === null || loginList === void 0 ? void 0 : loginList.some(function (loginItem) { return loginItem.company_id === companyid && loginItem.userid === userid; });
                            if (isLogin) {
                                item.is_login = true;
                            }
                            else {
                                item.is_login = false;
                            }
                        });
                        return [2 /*return*/, relatedList];
                }
            });
        });
    };
    MultiAccount.prototype.setAccountAppid = function (appid) {
        this.accountAppid = appid;
    };
    // 获取个人账号信息
    MultiAccount.prototype.getPersonalAccount = function (param) {
        return __awaiter(this, void 0, void 0, function () {
            var info, checkInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccounts(param)];
                    case 1:
                        _a.sent();
                        info = this.accounts.filter(function (info) { return info.company_id === 0; });
                        if (!!info) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getUserCheckInfo()];
                    case 2:
                        checkInfo = _a.sent();
                        if (checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.is_company_account) {
                            return [2 /*return*/, []];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, info];
                }
            });
        });
    };
    // 获取默认企业账号
    // 如果当前是个人账号切存在未清洗企业，返回第一个未清洗企业
    // 如果当前是企业账号，返回企业账号
    MultiAccount.prototype.getDefaultCompanyAccount = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var comps, infos, check, info;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getCompanyAccounts(true)];
                    case 1:
                        comps = _b.sent();
                        infos = comps.filter(function (account) { return account.is_current; });
                        if (infos.length == 1) {
                            return [2 /*return*/, infos[0]];
                        }
                        return [4 /*yield*/, this.getUserCheckInfo()];
                    case 2:
                        check = _b.sent();
                        if ((_a = this.userinfo) === null || _a === void 0 ? void 0 : _a.companyid) {
                            info = infos.find(function (info) { return info.company_id == _this.userinfo.companyid; });
                            if (info) {
                                return [2 /*return*/, info];
                            }
                        }
                        if (check === null || check === void 0 ? void 0 : check.is_company_account) {
                            return [2 /*return*/, check];
                        }
                        return [2 /*return*/, undefined];
                }
            });
        });
    };
    Object.defineProperty(MultiAccount.prototype, "userinfo", {
        get: function () {
            return getCache('userinfo');
        },
        set: function (v) {
            setCache('userinfo', v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiAccount.prototype, "isLoadCheck", {
        get: function () {
            return getCache('isLoadCheck');
        },
        set: function (v) {
            setCache('isLoadCheck', v);
        },
        enumerable: false,
        configurable: true
    });
    // private userinfo?: UserInfo
    // private isLoadCheck = false
    MultiAccount.prototype.getUserCheckInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.isLoadCheck || !this.userinfo)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, userCheck()];
                    case 1:
                        _a.userinfo = _b.sent();
                        this.isLoadCheck = true;
                        _b.label = 2;
                    case 2:
                        if (this.isLoadCheck && !this.userinfo) {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, {
                                userid: this.userinfo.userid,
                                is_company_account: this.userinfo.is_company_account,
                                company_id: this.userinfo.is_company_account ? this.userinfo.companyid : 0,
                                company_name: '',
                                company_logo: '',
                                avatar_url: this.userinfo.pic,
                                nickname: this.userinfo.nickname,
                                status: 1,
                                reason: '',
                                is_current: true,
                            }];
                }
            });
        });
    };
    // 获取当前账号身份信息
    // 如果当前是企业账号，返回企业账号
    // 如果当前是未清洗账号，返回 check 接口的companyid 对应的混合账号
    // 如果当前是纯个人账号，返回个人账号
    MultiAccount.prototype.getCurrentAccount = function (param) {
        var _a;
        if (param === void 0) { param = true; }
        return __awaiter(this, void 0, void 0, function () {
            var list, infos, info_1, check, info_2, info;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getAccounts(param)];
                    case 1:
                        list = _b.sent();
                        infos = list.filter(function (info) {
                            return info.is_current;
                        });
                        if (infos.length == 1) {
                            return [2 /*return*/, infos[0]];
                        }
                        // 没有获取到
                        if (infos.length == 0) {
                            return [2 /*return*/, this.getUserCheckInfo()];
                        }
                        // 通常是未清洗企业
                        if (this.companyid) {
                            info_1 = infos.find(function (info) { return info.company_id == _this.companyid; });
                            if (info_1) {
                                return [2 /*return*/, info_1];
                            }
                        }
                        return [4 /*yield*/, this.getUserCheckInfo()];
                    case 2:
                        check = _b.sent();
                        if ((_a = this.userinfo) === null || _a === void 0 ? void 0 : _a.companyid) {
                            info_2 = infos.find(function (info) { var _a; return info.company_id == ((_a = _this.userinfo) === null || _a === void 0 ? void 0 : _a.companyid); });
                            if (info_2) {
                                return [2 /*return*/, info_2];
                            }
                        }
                        info = infos.find(function (info) { return info.company_id; });
                        if (info) {
                            return [2 /*return*/, info];
                        }
                        return [2 /*return*/, check];
                }
            });
        });
    };
    // 获取所有企业账号
    MultiAccount.prototype.getCompanyAccounts = function (param) {
        return __awaiter(this, void 0, void 0, function () {
            var accounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccounts(param)];
                    case 1:
                        accounts = _a.sent();
                        return [2 /*return*/, accounts.filter(function (info) { return info.company_id > 0; })];
                }
            });
        });
    };
    // @descript 请使用 getCompanyAccountByid
    // 获取指定企业ID的账号
    MultiAccount.prototype.getCompanyAccount = function (companyid, param) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccounts(param)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.accounts.find(function (c) { return c.company_id == companyid; })];
                }
            });
        });
    };
    // 获取指定企业的所有账号
    MultiAccount.prototype.getCompanyAccountByid = function (companyid) {
        return __awaiter(this, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllModeAccounts()];
                    case 1:
                        list = _a.sent();
                        return [2 /*return*/, list.filter(function (c) { return c.company_id == companyid; })];
                }
            });
        });
    };
    // 用户是否有加入企业
    MultiAccount.prototype.hasCompany = function () {
        return __awaiter(this, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCompanyAccounts(true)];
                    case 1:
                        list = _a.sent();
                        return [2 /*return*/, !!list.length];
                }
            });
        });
    };
    // 用户是否有已清洗过的企业账号
    MultiAccount.prototype.hasCompanyAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCompanyAccounts(false)];
                    case 1:
                        list = _a.sent();
                        return [2 /*return*/, !!list.length];
                }
            });
        });
    };
    // 用户是否已登录
    MultiAccount.prototype.isUserLogin = function (userid) {
        return __awaiter(this, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccounts(true)];
                    case 1:
                        list = _a.sent();
                        return [2 /*return*/, !!list.find(function (info) { return info.userid == userid; })];
                }
            });
        });
    };
    MultiAccount.prototype.resetList = function () {
        this.isFetched = '';
        this.listCaches = {
            all_bind: [],
            current_login: []
        };
        this.accounts = []; // 账号变化后，更新账号信息列表
    };
    MultiAccount.prototype.onSwitchSuccess = function (params) {
        var _a;
        var options = params.options, info = params.info, isCurrentEnv = params.isCurrentEnv;
        if (info) {
            this.accounts = this.accounts.map(function (account) {
                account.is_current = false;
                if (account.userid == (info === null || info === void 0 ? void 0 : info.userid)) {
                    account.is_current = true;
                }
                return account;
            });
        }
        if (info && info.userid) {
            this.accountChangeHandler.forEach(function (fn) { return fn(info, isCurrentEnv); });
        }
        if (!info) {
            this.resetList();
        }
        (_a = options === null || options === void 0 ? void 0 : options.onSuccess) === null || _a === void 0 ? void 0 : _a.call(options, info);
    };
    MultiAccount.prototype.getAccountByID = function (userid, companyid) {
        var infos = this.accounts.filter(function (info) {
            return info.userid == userid;
        });
        var info = infos.length === 1 ? infos[0] : undefined;
        if (infos.length !== 1) {
            info = infos.find(function (info) {
                return info.userid == userid && info.company_id == (companyid || 0);
            });
        }
        return info;
    };
    // 切换到指定userid
    MultiAccount.prototype.switchAccount = function (params) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var userid, companyid, cbUrl, canJump, ssid, current, info, isLogin, info, checkinfo, e_1, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        userid = params.userid, companyid = params.companyid, cbUrl = params.cbUrl, canJump = params.canJump;
                        ssid = params.ssid;
                        if (!isSameDomain(ACCOUNT, window.location.href)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getCurrentAccount(true)
                            // 当前就是该账号
                        ];
                    case 1:
                        current = _b.sent();
                        // 当前就是该账号
                        if ((current === null || current === void 0 ? void 0 : current.userid) == userid) {
                            info = this.getAccountByID(userid, companyid);
                            this.companyid = (info === null || info === void 0 ? void 0 : info.company_id) || 0;
                            localStorage.setItem(storageCompID, String(this.companyid));
                            // params?.onSuccess?.(info)
                            this.onSwitchSuccess({ options: params, info: info, isCurrentEnv: true });
                            return [2 /*return*/, current];
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 11, , 12]);
                        if (!ssid) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.isUserLogin(userid)];
                    case 3:
                        isLogin = _b.sent();
                        if (isLogin) {
                            ssid = '';
                        }
                        _b.label = 4;
                    case 4: return [4 /*yield*/, switchAccount(userid, __assign(__assign({}, params), { cbUrl: cbUrl, canJump: canJump, appid: this.accountAppid, companyid: companyid, ssid: ssid }))];
                    case 5:
                        _b.sent();
                        if (companyid) {
                            this.companyid = companyid;
                        }
                        this.isLoadCheck = false;
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 9, , 10]);
                        info = this.getAccountByID(userid, companyid);
                        if (!!info) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.getUserCheckInfo()];
                    case 7:
                        checkinfo = _b.sent();
                        if (checkinfo && checkinfo.userid == userid) {
                            info = checkinfo;
                        }
                        _b.label = 8;
                    case 8:
                        if (info || companyid) {
                            this.companyid = (companyid || (info === null || info === void 0 ? void 0 : info.company_id));
                        }
                        window.localStorage.setItem(storageEventKey, JSON.stringify(info));
                        this.onSwitchSuccess({ options: params, info: info, isCurrentEnv: true });
                        return [2 /*return*/, info];
                    case 9:
                        e_1 = _b.sent();
                        throw e_1;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        e_2 = _b.sent();
                        (_a = params.onFail) === null || _a === void 0 ? void 0 : _a.call(params, e_2);
                        throw e_2;
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    // @desperate: 同个企业也会存在多个已登录账号，多登需求后不再合适使用，请使用 switchAccount
    // 切换到指定企业
    MultiAccount.prototype.switchCompany = function (p) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('use switchAccount please!');
            });
        });
    };
    // @desperate: 个人账号可能会有多个，多登需求后不再合适使用，请使用 switchAccount
    // 切换到个人账号
    MultiAccount.prototype.switchPersonal = function (p) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('use switchAccount please!');
            });
        });
    };
    /**
     * 获取指定企业清洗状态
     * @return {CompanyStatus}
     */
    MultiAccount.prototype.companyStatus = function (companyid) {
        return __awaiter(this, void 0, void 0, function () {
            var compAccount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // 获取关联和已登录账号用于识别类型
                    return [4 /*yield*/, this.getAccounts({ mode: 'all_bind', legacy: true })];
                    case 1:
                        // 获取关联和已登录账号用于识别类型
                        _a.sent();
                        return [4 /*yield*/, this.getAccounts({ mode: 'current_login', legacy: true })];
                    case 2:
                        _a.sent();
                        compAccount = __spreadArray(__spreadArray([], this.listCaches['all_bind'], true), this.listCaches['current_login'], true).find(function (info) { return info.company_id == companyid; });
                        if (!compAccount) {
                            return [2 /*return*/, CompanyStatus.noaccess];
                        }
                        if (compAccount.is_company_account) {
                            return [2 /*return*/, CompanyStatus.normal];
                        }
                        return [2 /*return*/, CompanyStatus.legacy];
                }
            });
        });
    };
    // 获取指定企业的使用状态
    MultiAccount.prototype.companyState = function (companyid) {
        return __awaiter(this, void 0, void 0, function () {
            var loginList, current, getState, state, clientSupport, relatedList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccounts({ mode: 'current_login', legacy: true })];
                    case 1:
                        loginList = _a.sent();
                        return [4 /*yield*/, this.getCurrentAccount(true)
                            // console.log(companyid, current)
                        ];
                    case 2:
                        current = _a.sent();
                        getState = function (list, type) {
                            var comps = list.filter(function (info) { return info.company_id == companyid; });
                            if (!comps.length) {
                                return CompanyState.noaccess;
                            }
                            var isCurrent = comps.some(function (comp) { return comp.userid == (current === null || current === void 0 ? void 0 : current.userid); });
                            if (isCurrent) {
                                return CompanyState.current;
                            }
                            if (type == 'current_login') {
                                return CompanyState.login;
                            }
                            else {
                                return CompanyState.related;
                            }
                        };
                        state = getState(loginList, 'current_login');
                        if (state != CompanyState.noaccess) {
                            return [2 /*return*/, state];
                        }
                        return [4 /*yield*/, this.isClientSupport()];
                    case 3:
                        clientSupport = _a.sent();
                        if (!clientSupport) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getAccounts({ mode: 'all_bind', legacy: true })];
                    case 4:
                        relatedList = _a.sent();
                        return [2 /*return*/, getState(relatedList, 'all_bind')];
                    case 5: return [2 /*return*/, state];
                }
            });
        });
    };
    MultiAccount.prototype.listenUserChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var source, isok;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        source = clientApi.getCurrentClient();
                        return [4 /*yield*/, clientApi.checkClientAPISupport(source, 'onAccountChange')];
                    case 1:
                        isok = _a.sent();
                        if (isok) {
                            clientApi.onAccountChange({
                                clientName: source,
                                handler: function (info) {
                                    _this.accountChangeHandler.forEach(function (fn) { return fn(info, false); });
                                }
                            });
                        }
                        else {
                            window.addEventListener('storage', function (e) {
                                if (e.key !== storageEventKey) {
                                    return;
                                }
                                var info;
                                try {
                                    info = JSON.parse(e.newValue || '');
                                }
                                catch (e) {
                                    return;
                                }
                                if (!info) {
                                    return;
                                }
                                if (info.userid) {
                                    _this.onSwitchSuccess({ info: info, isCurrentEnv: false });
                                }
                            });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 当账号身份发生变化时触发
     */
    MultiAccount.prototype.onAccountChange = function (handler) {
        this.accountChangeHandler.push(handler);
    };
    return MultiAccount;
}());
var multiAccount = new MultiAccount();

export { CompanyState, CompanyStatus, MultiAccount, apiSwitch, multiAccount as default, fixLegacyAccounts, kdocsSingleSignSwitch };
